import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { FixedHeaderCmp, FixedHeaderProps } from "./FixedHeader"

interface FixedHeaderWrapperBlokProps {
  blok: FixedHeaderProps & blokType
}

const S22FixedHeader: React.FC<FixedHeaderWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <FixedHeaderCmp
      cta_button={blok.cta_button}
      background_color={blok.background_color}
    />
  </SbEditable>
)

export default S22FixedHeader
